import React from 'react';
import { useScreenConfiguration } from '../../../Hooks/Features/TaskLayout/Screens/useScreenConfiguration';
import CommonGrid from '../../CommonCompo/CommonGrid/CommonGrid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MultiSelect } from 'primereact/multiselect';
import PanelHeaderTemplate from '../../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate';
import _ from "underscore"
import { Dialog } from 'primereact/dialog';
import { renderField } from '../../../utils/Helper';
import { faCircleXmark, faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import CommanDialog from '../../CommonCompo/CommanDialog/CommanDialog';

const ScreenConfiguration = ({ filterValues, setFilterValues, }) => {
    const { columns, fieldData, option, multiSelectRef, formJson, tabList, fieldValues, setFieldValues, screenCrudTab, upsertFieldInScreen, filterData, loader, visible, setVisible } = useScreenConfiguration({ filterValues, setFilterValues });

    return (
        <div className="">
            <div className='d-flex gap-4 align-items-center justify-content-between'>
                <div className='d-flex gap-2 align-items-center px-2'>
                    <button className='sk-btn sk-btn-primary' onClick={() => setFilterValues((prev) => ({ ...prev, config: {}, apiCall: true, activeTab: null }))}>
                        <FontAwesomeIcon icon="fa-solid fa-angle-left" className='c-pointer' />
                    </button>
                    <h5 className='fw-bold'>Manage Field: {filterValues?.config?.screen_name}</h5>
                </div>
            </div>
            <div className='d-flex border-bottom px-2 my-2 align-items-center' style={{ gap: '4px' }}>
                {
                    tabList?.map((value) => {
                        const isActive = filterValues?.activeTab?.tab_id === value?.tab_id;
                        return (
                            <div
                                key={value?.tab_id}
                                className={`d-flex align-items-center gap-2 px-2 py-2 c-pointer transition-all fw-bold ${isActive
                                    ? "border-bottom border-2 border-dark "
                                    : "text-secondary border-bottom border-3"
                                    }`}
                                style={{ marginBottom: '-2px', cursor: 'pointer' }}
                                onClick={() => {
                                    setFilterValues((prev) => ({ ...prev, activeTab: value, apiCall: true }))
                                }}
                            >
                                <span className='text-capitalize'>{value?.tab_name}</span>

                                <div className="d-flex gap-2">
                                    <FontAwesomeIcon
                                        icon={faPenToSquare}
                                        className="text-muted hover-primary"
                                        onClick={(e) => {
                                            setVisible({ tab: true, row: value });
                                            setFieldValues((prev) => ({ ...prev, tab: value?.tab_name }));
                                        }}
                                    />
                                    <FontAwesomeIcon
                                        icon={faCircleXmark}
                                        className="text-muted hover-danger"
                                        onClick={(e) => { setVisible((prev) => ({ ...prev, tabDelete: true })) }
                                        }
                                    />
                                </div>
                            </div>
                        )
                    })
                }
                <button
                    className='btn btn-primary p-2 ms-2'
                    onClick={() => setVisible((prev) => ({ ...prev, tab: true, isNew: true }))}
                >
                    <FontAwesomeIcon icon={faPlus} /> Add Tab
                </button>
            </div>
            <div className="mt-2 d-flex">
                <div className='w70 px-2' style={{ height: "calc(100vh - 200px)", overflow: "auto" }}>
                    <CommonGrid columns={columns} data={[{ id: "all", title: "", children: filterData }]} expandAll={true} rowHeight={35} headerHeight={50} strippedTable={true} />
                </div>
                <div className='w30 px-2' style={{ height: "calc(100vh - 200px)" }}>
                    <div className='d-flex justify-content-end align-items-center py-1'>
                        <button type="button" className="sk-btn sk-btn-primary bg-black text-white" onClick={() => upsertFieldInScreen()} ><FontAwesomeIcon icon="fa-solid fa-check" /> Apply</button>
                    </div>
                    <div className='rounded' style={{ height: "calc(100% - 60px)" }}>
                        <div className='d-flex align-items-center justify-content-between' style={{ position: "relative" }}>
                            <div className='w10 text-center'>
                                <input type='checkbox' checked={_.isEqual(_.sortBy(_.pluck(option?.fields, "custom_field_id")), _.sortBy(fieldValues?.field))} onChange={(e) => { setFieldValues((prev) => ({ ...prev, field: e?.target?.checked ? _.pluck(option?.fields, "custom_field_id") : [] })); }} />
                            </div>
                            <input className='sk-input-dd w90' placeholder='Search Fields...' value={fieldValues?.search || ""} onChange={(e) => setFieldValues((prev) => ({ ...prev, search: e?.target?.value }))} />
                            <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" style={{ position: "absolute", top: "10px", right: "10px", zIndex: 9999 }} />
                        </div>
                        <div style={{ height: "93%", overflowY: "auto" }}>
                            {option?.fields?.map(field => {
                                const isSelected = fieldValues?.field?.includes(field?.custom_field_id);
                                return (
                                    <div key={field?.custom_field_id} className='px-3 py-2 d-flex gap-3 align-items-center c-pointer screen-field-li' 
                                    // style={{ backgroundColor: isSelected ? "#e0efff" : "white" }}
                                        onClick={() => setFieldValues((prev) => ({ ...prev, field: isSelected ? [...(prev?.field || [])?.filter(item => item !== field?.custom_field_id)] : [...(prev?.field || []), field?.custom_field_id], isChange: true }))}
                                    >
                                        <input type='checkbox' checked={isSelected} />
                                        <div className='fw-semibold'>{field?.custom_field_name}</div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <Dialog
                draggable={false}
                header="New field set tab"
                visible={visible?.tab}
                onHide={() => { setVisible({ tab: false }); setFieldValues((prev) => ({ ...prev, tab: "" })) }}
                className='modal-xsmall'>
                <div>
                    <div className='row'>
                        {
                            formJson?.map((item, index) => (
                                renderField(item, index, (e) => setFieldValues((prev) => ({ ...prev, tab: e.target.value, isChange: true })), fieldValues, {}, {
                                    is_edit: item?.textField, fromProject: 0
                                }, () => { }, () => { })
                            ))
                        }
                    </div>
                    <div className='d-flex gap-2 align-items-center justify-content-end'>
                        <button className='sk-btn sk-btn-primary' onClick={() => { setVisible({ tab: false }); setFieldValues((prev) => ({ ...prev, tab: "" })) }}>Cancel</button>
                        <button className='sk-btn text-white bg-black sk-btn-primary' onClick={() => screenCrudTab()} >Submit</button>
                    </div>
                </div>
            </Dialog>
            <CommanDialog
                visible={visible?.tabDelete}
                message={"Are You Sure You Want to delete this tab?"}
                handleClose={() => { setVisible((prev) => ({ ...prev, tabDelete: false })) }}
                handleFun={() => {
                    screenCrudTab(true)
                }}
                loader={loader?.btn}
            />
            <CommanDialog
                visible={visible?.delete}
                message={"Are You Sure You Want to delete this field?"}
                handleClose={() => { setVisible((prev) => ({ ...prev, delete: false })) }}
                handleFun={() => {
                    upsertFieldInScreen(true)
                }}
                loader={loader?.btn}
            />
        </div>
    );
};


export default ScreenConfiguration;